import React from 'react';
import { Phone } from 'lucide-react';

const Footer = ({ handleNavClick }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>Bartlett Enterprises</h3>
            <p>Professional home improvement services you can trust. Insured and dedicated to delivering excellence with our 6-year workmanship warranty.</p>
            <div style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
              <Phone size={18} />
              <span>(518) 792-0200</span>
            </div>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li><a href="#services" onClick={(e) => { e.preventDefault(); handleNavClick('services'); }}>Roofing</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); handleNavClick('services'); }}>Siding</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); handleNavClick('services'); }}>Windows</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); handleNavClick('services'); }}>Carpentry</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul className="footer-links">
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); handleNavClick('contact'); }}>Contact</a></li>
              <li><a href="#home" onClick={(e) => { e.preventDefault(); handleNavClick('home'); }}>6-Year Warranty</a></li>
              <li><a href="#service-areas" onClick={(e) => { e.preventDefault(); handleNavClick('service-areas'); }}>Service Areas</a></li>
              <li><a href="#faq" onClick={(e) => { e.preventDefault(); handleNavClick('faq'); }}>FAQ</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy;2025 Bartlett Enterprises. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;